
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { CurrencySource } from '@/Sources';

  @Component({
    name: 'currency-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class CurrencyDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Currency' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;

    public source: CurrencySource = new CurrencySource();

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
